import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { inventoryFBAForecast: { getInventoryFBAForecast } } = apiUrls;

export const GET_INVENTORY_FBA_FORECAST_SUCCESS = 'GET_INVENTORY_FBA_FORECAST_SUCCESS';
export const GET_INVENTORY_FBA_FORECAST_LOADING = 'GET_INVENTORY_FBA_FORECAST_LOADING';


export const getInventoryFBAForecastData = ({ date }) => async (dispatch) => {
    try {
        const { url } = getInventoryFBAForecast
        const requestData = {
            ...getInventoryFBAForecast,
            url: url.replace('{{date}}', date)
        };
        const data = await REQUEST(requestData);
        dispatch({
            type: GET_INVENTORY_FBA_FORECAST_SUCCESS,
            data,
        })
    } catch (e) {

        dispatch({
            type: GET_INVENTORY_FBA_FORECAST_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            }
        })
    }

}



export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: GET_INVENTORY_FBA_FORECAST_LOADING,
        isLoading
    })
}
